<template>
    <div>
        <vk-tabs-vertical align="left" :keep-alive="true" v-if="veiculo && ! isMobile">
            <vk-tabs-item title="RELATÓRIOS NO PORTAL" >
                <relatorios :uuid="veiculo.uuid" :id_cliente="veiculo.id_cliente"></relatorios>
            </vk-tabs-item>

            <vk-tabs-item title="HISTÓRICO">
                <relatorio-periodo :id_rastreador="veiculo.id_rastreador"/>
            </vk-tabs-item>

            <vk-tabs-item title="ALERTAS">
                <relatorio-alertas :uuid="veiculo.uuid"/>
            </vk-tabs-item>
        </vk-tabs-vertical>
        <vk-tabs align="left" :keep-alive="true" v-if="veiculo && isMobile">
            <vk-tabs-item title="RELATÓRIOS NO PORTAL" >
                <relatorios :uuid="veiculo.uuid" :id_cliente="veiculo.id_cliente"></relatorios>
            </vk-tabs-item>

            <vk-tabs-item title="ALERTAS">
                <relatorio-alertas :uuid="veiculo.uuid"/>
            </vk-tabs-item>
        </vk-tabs>
    </div>

</template>

<script>
import RelatorioAlertas from '../../relatorios/RelatorioAlertas.vue';
import RelatorioPeriodo from '../../relatorios/RelatorioPeriodo.vue';
import Relatorios from '../../veiculo/Relatorios.vue';
import {isMobile} from 'mobile-device-detect';

export default {
    name: 'DadosRelatoriosAdmin',
    components: {Relatorios, RelatorioPeriodo, RelatorioAlertas},
    props: {
        veiculo: null
    },
    data () {
        return {
            isMobile: isMobile
        }
    }
};
</script>

<style scoped>

</style>
